import { FOOTER, SHOW_FOOTER, SHOW_FOOTER_UI, } from "@frameworks/web/redux/interfaces/IFooter";
const initState = {
    data: {
        data: [],
    },
    showFooter: true,
    showFooterUi: true,
};
const footer = (state = initState, action) => {
    switch (action.type) {
        case FOOTER:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case SHOW_FOOTER:
            return Object.assign(Object.assign({}, state), { showFooter: action.payload.showFooter });
        case SHOW_FOOTER_UI:
            return Object.assign(Object.assign({}, state), { showFooterUi: action.payload.showFooterUi });
        default:
            return Object.assign({}, state);
    }
};
export default footer;
